import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(authenticated)/patients/$patientId/monthly-care-log')({});
